import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { EverythingWrapperProps } from '@widgets/Teaser/playlist/types'
import { mobileCSS, desktopCSS, tabletCSS } from '@measures/responsive'
import Blink from '@components/Blink'

const StyledEverythingWrapper = styled(Blink)`
  display: block;
  position: relative;
  width: 100%;
  height: 0;
  text-decoration: none;
  overflow: hidden;

  ${desktopCSS(css`
    padding-bottom: 100px;
  `)}

  ${tabletCSS(css`
    padding-bottom: 123px;
  `)}

  ${mobileCSS(css`
    padding-bottom: 150px;
  `)}
`

const EverythingWrapper: FunctionComponent<EverythingWrapperProps> = ({
  children,
  clickableProps,
}) => {
  return (
    <StyledEverythingWrapper {...clickableProps}>
      {children}
    </StyledEverythingWrapper>
  )
}

export default EverythingWrapper
